import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

/** Where a paid-up coach lands: the app's default route. */
export const APP_HOME = '/players';

/**
 * Sends a coach whose organization has just stopped awaiting payment into the app.
 *
 * The profile is re-read first. Until it is, AuthContext still says "awaiting payment" and
 * `ProtectedRoute` would bounce them straight back to `/signup/payment`. If the re-read fails, the
 * caller shows `error` with a retry rather than navigating into that bounce.
 */
export const useEnterApp = () => {
  const { refreshProfile } = useAuth();
  const navigate = useNavigate();
  const [entering, setEntering] = useState(false);
  const [error, setError] = useState('');

  const enterApp = useCallback(async () => {
    setEntering(true);
    setError('');
    try {
      await refreshProfile();
      navigate(APP_HOME, { replace: true });
    } catch {
      setError('Your account is active, but we could not open RosterPilot. Please try again.');
    } finally {
      setEntering(false);
    }
  }, [refreshProfile, navigate]);

  return { enterApp, entering, error };
};
